import { render, staticRenderFns } from "./documentPreviewTable.vue?vue&type=template&id=29ab6c20&scoped=true"
import script from "./documentPreviewTable.vue?vue&type=script&lang=js"
export * from "./documentPreviewTable.vue?vue&type=script&lang=js"
import style0 from "./documentPreviewTable.vue?vue&type=style&index=0&id=29ab6c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ab6c20",
  null
  
)

export default component.exports